var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStep1 = function SvgStep1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E0F2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#026AA2",
    d: "M19.477 25.11V12.602l1.096 1.135H16.63v-2.097h5.349v13.468h-2.501Z"
  })));
};
export { SvgStep1 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNFMEYyRkUiLz4KPHBhdGggZD0iTTE5LjQ3NjcgMjUuMTA5NFYxMi42MDNMMjAuNTczNCAxMy43MzgySDE2LjYyOTFWMTEuNjQxSDIxLjk3OFYyNS4xMDk0SDE5LjQ3NjdaIiBmaWxsPSIjMDI2QUEyIi8+Cjwvc3ZnPg==";